import React from "react";

interface CharacterCounterProps {
  length: number;
  /** Hard limit: typing stops here. */
  limit?: number | null;
  /** Past this the canvas shows "… more"; still allowed. */
  softLimit?: number | null;
  className?: string;
}

/**
 * "80/125" under a text field. Grey normally, amber once the text runs past the
 * soft limit (it will be cut to "… more" on the ad), red at the hard limit.
 */
const CharacterCounter: React.FC<CharacterCounterProps> = ({
  length,
  limit,
  softLimit,
  className = "",
}) => {
  if (!limit && !softLimit) return null;

  const atLimit = Boolean(limit) && length >= (limit as number);
  const pastSoft = Boolean(softLimit) && length > (softLimit as number);

  const tone = atLimit ? "text-red-600" : pastSoft ? "text-amber-600" : "text-gray-500";
  const hint = atLimit
    ? "Character limit reached"
    : pastSoft
      ? `Shown as "… more" after ${softLimit} characters`
      : null;

  return (
    <div className={`mt-1 flex items-center justify-between gap-2 text-xs ${tone} ${className}`}>
      <span>{hint}</span>
      <span className="tabular-nums">
        {length}
        {limit ? `/${limit}` : ""}
      </span>
    </div>
  );
};

export default CharacterCounter;
